import { store } from '@store/store';

import { setSnackbar } from '@slices/common';

import { IResponseError } from '@interfaces/errors/apiErrors';

import { ESnackbarTypes } from '@enums/common';
import { EErrorCodes, PermissionErrorCause } from '@enums/errorCodes';

import { responseMessages } from '@constants/responseMessages';

export const handleErrorFromMessage = (err: IResponseError) => {
	const isPermissionError = err?.cause === PermissionErrorCause;

	err?.errors?.forEach(error => {
		const message = isPermissionError
			? EErrorCodes.permissionError
			: error?.message || err.originalErrorMessage || responseMessages.error;

		store.dispatch(setSnackbar({
			type: ESnackbarTypes.error,
			message,
		}));
	});
};
